import { render } from "./EmbeddedApplication.vue?vue&type=template&id=060704e6&ts=true"
import script from "./EmbeddedApplication.vue?vue&type=script&lang=ts"
export * from "./EmbeddedApplication.vue?vue&type=script&lang=ts"

import "./EmbeddedApplication.vue?vue&type=style&index=0&id=060704e6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__